module.exports = __webpack_public_path__ + "static/media/hindustan_times.de3154e4.svg";